import React, {useCallback} from 'react'
import {MorePage} from './MorePage.tsx'

export interface MorePageContainerProps {
    onNavigate: (path: string) => void
    onExternalNavigate: (url: string) => void
    onLanguageClick: () => void
    onRulebookClick: () => void
}

export const MorePageContainer = ({
    onNavigate,
    onExternalNavigate,
    onLanguageClick,
    onRulebookClick,
}: MorePageContainerProps) => {
    // TODO: Muhammad - add notification logic
    const showPatchNotesNotification = false
    const showCareersNotification = false

    const onPatchNotesClick = useCallback(() => onNavigate('/patch-notes'), [onNavigate])
    const onFaqClick = useCallback(() => onNavigate('/faq'), [onNavigate])
    const onChampionshipClick = useCallback(() => onNavigate('/championship2026'), [onNavigate])
    const onPlayerHubClick = useCallback(() => onNavigate('/community'), [onNavigate])
    const onBlogClick = useCallback(() => onExternalNavigate('https://blog.colonist.io/'), [onExternalNavigate])
    const onAboutClick = useCallback(() => onNavigate('/about'), [onNavigate])
    const onCareersClick = useCallback(() => onNavigate('/careers'), [onNavigate])
    const onPrivacyClick = useCallback(() => onNavigate('/privacy-policy'), [onNavigate])

    return (
        <MorePage
            showPatchNotesNotification={showPatchNotesNotification}
            showCareersNotification={showCareersNotification}
            onPatchNotesClick={onPatchNotesClick}
            onLanguageClick={onLanguageClick}
            onRulebookClick={onRulebookClick}
            onFaqClick={onFaqClick}
            onChampionshipClick={onChampionshipClick}
            onPlayerHubClick={onPlayerHubClick}
            onBlogClick={onBlogClick}
            onAboutClick={onAboutClick}
            onCareersClick={onCareersClick}
            onPrivacyClick={onPrivacyClick}
        />
    )
}
